<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Promoters | Gerenciar | Criar" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-affiliate
            :affiliate="affiliate"
            @submit="($model: Affiliate) => submit($model)"
          />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import AffiliateService from '@/services/AffiliateService'
import type Affiliate from '@/types/Affiliate'
import FormAffiliate from './form-affiliate.vue'

export default defineComponent({
  components: {
    TPageTitle,
    FormAffiliate,
  },
  data() {
    return {
      affiliate: {
        name: '',
        email: '',
        tag: '',
        observation: '',
      } as Affiliate,
      resource: 'affiliates',
    }
  },
  computed: {},
  mounted() {
    console.log(this)
  },
  methods: {
    async submit(model: Affiliate) {
      try {
        await new AffiliateService().store(model)

        this.$snackbar.show('Promoter criado com sucesso', 'success')

        this.$router.push({ name: 'list-affiliates' })
      } catch (error) {
        this.$snackbar.show('Você não foi possível criar o promoter', 'error')

        throw error
      }
    },
  },
})
</script>
